const BASE_URL = "https://flightinsiders.com/" // main domain
// const BASE_URL = "http://localhost/flight/" // local
// const BASE_URL = "https://kgt.e1a.mywebsitetransfer.com/" // technical domain
export const API_JSON_BASE_URL = `${BASE_URL}content/`;
export const API_BASE_URL = `${BASE_URL}api/`;
export const IMG_BASE_URL = `${BASE_URL}images/`;